import { useEffect, useState } from "react";

function fmt(ms) {
  if (ms <= 0) return "0:00";
  const total = Math.ceil(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

/**
 * useCountdown(deadlineIso)
 * Returns { remainingMs, label, expired } based on a target ISO datetime.
 * Ticks every 500ms while active; stops when deadline is null.
 */
export function useCountdown(deadlineIso) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!deadlineIso) return undefined;
    const id = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(id);
  }, [deadlineIso]);

  if (!deadlineIso) return { remainingMs: 0, label: "", expired: false, active: false };

  const target = new Date(deadlineIso).getTime();
  const remainingMs = target - now;
  return {
    active: true,
    remainingMs,
    label: fmt(Math.max(0, remainingMs)),
    expired: remainingMs <= 0,
  };
}
